module.exports = __webpack_public_path__ + "static/img/cross-red.811334ee.png";